export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-picasa-d7500f5692785a4b66a5ce02f09c600f.svg";